export default __webpack_public_path__ + "static/media/Baby13.2b8ffb0a.gif";